import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
declare var $: any;

@Component({
  selector: 'app-qdltext-box',
  templateUrl: './qdltext-box.component.html',
  styleUrls: ['./qdltext-box.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class QDLTextBoxComponent implements OnInit, OnChanges {

  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions;
  answerImagesLength: number;
  remainingCharacters: number;
  ReEnterBlankMessage: string;
  range: boolean;
  DateFormatType: any;

  constructor(public service: ParticipationDataService) {}

  ngOnChanges(changes: SimpleChanges) {
    let change = changes['JsonData'];

    let curVal = JSON.stringify(change.currentValue);
    let preVal = JSON.stringify(change.previousValue);

    if (curVal != preVal && preVal != undefined) {
      this.questions = JSON.parse(this.JsonData);
    }
  }

  ngOnInit() {
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);

      let updateItem = this.questions.Answers.find(
        e => e.hasImage && e.AnswerImages.length == 2);

      if (updateItem != null && updateItem != undefined) {
        this.answerImagesLength = 2;
      } else {
        updateItem = this.questions.Answers.find(
          e => e.hasImage && e.AnswerImages.length == 1);

        if (updateItem != null && updateItem != undefined) {
          this.answerImagesLength = 1;
        }
      }

      if (this.questions.qsubtype == 11) {
        this.questions.num_range_1 = '1';
        this.questions.num_range_2 = '5';
      }

      if (this.questions.qsubtype == 12) {
        this.questions.num_range_1 = '1';
        this.questions.num_range_2 = '9';
      }

      if (this.questions.qsubtype == 19) {
        this.questions.num_range_2 = '10';
      }

      if (this.questions.Showcharlimit) {
        this.remainingCharacters = this.questions.characterLimit;

        if (this.questions.AnswerText != null) {
          this.remainingCharacters = this.questions.characterLimit - this.questions.AnswerText.length;
        }
      }

      if(this.service.getReEnterBlankMessage()){
        this.ReEnterBlankMessage = this.service.getReEnterBlankMessage();
      }
    }
  }

  onBlurMethod(event: any, curVal: any) {

    if (this.questions.AnswerText == "") {
      this.questions.AnswerText = null;
    }

    if (curVal == "") {
      this.questions.isValid = false;
      this.questions.AnswerText = null;

      if (this.questions.qsubtype == 31) {
        this.questions.isReEnterEmailValid = false;
      }

      this.ChangeAnswersData.emit(this.questions);
      return;
    }

    if (this.questions.qsubtype == 22 ||
      this.questions.qsubtype == 41 ||
      this.questions.qsubtype == 21) {
      this.NumberValidation(event, curVal);
    }
    else if (this.questions.qsubtype == 11) {
      this.PostalCodeValidation(curVal);
    }
    else if (this.questions.qsubtype == 61 || this.questions.qsubtype == 62) {
      this.PhoneValidation(curVal);
    }
    else if (this.questions.qsubtype == 51) {
      this.SSNValidation(curVal);
    }
    else if (this.questions.qsubtype == 12) {
      this.PostalCodePlusFourValidation(curVal);
    }
    else if (this.questions.qsubtype == 10) {
      this.CustomValidation(curVal);
    }
    else if (this.questions.qsubtype == 31) {
      this.EmailValidation(curVal);
    }
    else if (this.questions.qsubtype == 1 || this.questions.qsubtype == 2 || this.questions.qsubtype == 3 || this.questions.qsubtype == 4) {
      this.ValidateDate(event, curVal);
      this.DatePickerValidation(event, curVal);
    }
    else if (this.questions.qsubtype == 63 || this.questions.qsubtype == 64) {
      this.ValidateNumPhone(curVal);
    }
    this.questions.pageto = this.questions.Answers[0].pageto;
    this.ChangeAnswersData.emit(this.questions);

    this.ChangeAnswersData.emit(this.questions);
  }

  keytab(event: any, curVal: string) {
    if (this.questions.Showcharlimit) {
      this.remainingCharacters = this.questions.characterLimit - curVal.length;
    }
  }

  NumberValidation(event: any, curVal: any) {
    this.range = false;
    let curValue1 = parseInt(curVal);
    let min1 = parseInt(this.questions.num_range_1);
    let max1 = parseInt(this.questions.num_range_2);

    if (curVal != "") {
      if (isNaN(curVal) || (curValue1 < min1 || curValue1 > max1)) {
        this.range = true;
        this.questions.isValid = true;
        return;
      }
      else {
        this.questions.isValid = false;
      }
    } else {
      this.questions.isValid = true;
    }
  }

  PhoneValidation(objTextBox: any) {
    let phone = objTextBox;

    if (phone == "") {
      return true;
    }

    let matchArr1 = phone.match(/^(\d{10})$/);
    let matchArr2 = phone.match(/^(\d{3})-?\d{3}-?\d{4}$/);
    let matchArr3 = phone.match(/^(\d{3})-?\d{7}$/);
    let matchArr4 = phone.match(/^\(\d{3}\)\s\d{3}-\d{4}$/);

    if (matchArr1 != null || matchArr2 != null || matchArr3 != null || matchArr4 != null) {
      if (matchArr4 == null) {
        phone = phone.replace(/-/g, '');
        phone = '(' + phone.substring(0, 3) + ') ' + phone.substring(3, 6) + '-' + phone.substring(6, 10);
      }
      this.questions.AnswerText = phone;
      this.questions.isValid = false;
      this.range = false;
      return true;
    }
    else {
      this.range = true;
      this.questions.isValid = true;
      return false;
    }
  }

  PostalCodeValidation(curVal: any) {
    this.range = false;

    if (curVal != "" && isNaN((curVal) || curVal.length < 5)) {
      this.range = true;
      this.questions.isValid = true;
      return;
    }
    else {
      this.questions.isValid = false;
    }
  }

  SSNValidation(curVal: any) {
    let matchArr1 = curVal.match(/^(\d{9})$/);
    let matchArr2 = curVal.match(/^(\d{3})-?\d{2}-?\d{4}$/);

    if (matchArr1 != null ||matchArr2 != null) {
      this.questions.isValid = false;
    }
    else {
      this.range = true;
      this.questions.isValid = true;
      return;
    }
  }

  PostalCodePlusFourValidation(curVal: any) {

    if (curVal != "" && (isNaN(curVal) ||
      (curVal.length != 5 && curVal.length < 9) || curVal.length > 9)) {
      this.range = true;
      this.questions.isValid = true;
      return;
    }
    else {
      this.questions.isValid = false;
    }
  }

  EmailValidation(curVal: string) {

    const regexp = new RegExp(/^([a-zA-Z0-9_\.\'\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z])+$/);

    let isValid = regexp.test(curVal);

    if (isValid) {
      this.range = false;
      this.questions.isReEnterEmail = false;
      this.questions.isValid = false;

      let control = document.getElementById('Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID_ReEnter');

      setTimeout(function () {
        control.focus();
      }, 0);


    } else {
      this.range = true;
      this.questions.isReEnterEmail = true;
      this.questions.isValid = true;
      this.questions.otherAnswer = null;
      this.questions.isReEnterEmailValid = false;
    }
  }

  CustomValidation(curVal: string) {
    this.VCF(curVal, this.questions.error_msg, this.questions.custom_format, this.questions.custom_format)
  }

  VCF(Tboxvalue, strErrMsg, custom_format, row) {
    if (Tboxvalue.length > 0 && Tboxvalue.length == row.length) {
      for (let i = 0; i < row.length; i++) {
        var TB = Tboxvalue.toString().charAt(i)
        var characters = TB.match(/^[a-zA-Z]*$/)
        var numbers = TB.match(/^[0-9]*$/)
        var RowIndex = row.toString().charAt(i)
        if ((characters == null && RowIndex == "@") || (numbers == null && RowIndex == "#")) {
          var isValid = true
          break;
        } else if ((characters != null && RowIndex == "@") || (numbers != null && RowIndex == "#")) { } else if (TB == RowIndex) { } else {
          var isValid = true
          break;
        }
      }
    } else if (Tboxvalue.length == custom_format.length) {
      for (let i = 0; i < custom_format.length; i++) {
        var TB = Tboxvalue.toString().charAt(i)
        var characters = TB.match(/^[a-zA-Z]*$/)
        var numbers = TB.match(/^[0-9]*$/)
        var RowIndex = custom_format.toString().charAt(i)
        if ((characters == null && RowIndex == "@") || (numbers == null && RowIndex == "#")) {
          var isValid = true
          break;
        } else if ((characters != null && RowIndex == "@") || (numbers != null && RowIndex == "#")) { } else if (TB == RowIndex) { } else {
          var isValid = true
          break;
        }
      }
    } else {
      var isValid = true
    }

    if (isValid) {
      this.range = true;
      this.questions.isValid = true;
      return false;
    } else if (Tboxvalue.length != 0) {
      let Custom = this.CustomForm(custom_format, Tboxvalue)
      this.questions.isValid = false;
      return Custom
    }
  }

  CustomForm(custom_format, Tboxvalue) {
    for (let k = 0; k < custom_format.length; k++) {
      var CustomFormatIndex = custom_format.toString().charAt(k)
      if ((Tboxvalue.length != custom_format.length) &&
        (CustomFormatIndex.match(/^[a-zA-Z]*$/) == null &&
          CustomFormatIndex.match(/^[0-9]*$/) == null)) {

        if (CustomFormatIndex != "@" && CustomFormatIndex != "#") {
          var abc = CustomFormatIndex;
          var strLeft = Tboxvalue.substring(0, k);
          var strRight = Tboxvalue.substring(k + 1, custom_format.length);
          var str = strLeft + abc + strRight
          Tboxvalue = str
        }
      }
    }
    return Tboxvalue
  }

  DatePickerValidation(event: any, curVal: any) {
    if (curVal != "" && this.questions.isValid != true) {
      if (isNaN(curVal)) {
        this.questions.isValid = false;
        this.questions.AnswerText = curVal;
        return;
      }
      else {
        this.questions.isValid = false;
      }
    } else {
      this.questions.isValid = true;
    }
  }
  separator: string;
  posDate: any;
  posMonth: any;
  posYear: any;
  lenYear: any;
  setDateVariables(intDateFormatType) {
    switch (intDateFormatType) {
      case 1:
        this.separator = "/"
        this.posDate = 1
        this.posMonth = 0
        this.posYear = 2
        this.lenYear = 4
        break;
      case 2:
        this.separator = "/"
        this.posDate = 0
        this.posMonth = 1
        this.posYear = 2
        this.lenYear = 4
        break;
    }
  }

  isLeapYear(year) {
    return (((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0)) ? true : false;
  }

  ValidateDate(event: any, curVal: any) {

    let strDate = curVal;

    this.setDateVariables(this.DateFormatType)

    let arrDate = strDate.split(this.separator)

    if (arrDate.length != 3) {
      this.questions.isValid = true;
      return;
    }
    if (arrDate[0] == "" || arrDate[1] == "" || arrDate[2] == "" || arrDate[this.posMonth].length > 2 || arrDate[this.posDate].length > 2 || arrDate[this.posYear].length != this.lenYear || arrDate[this.posYear] < 1) {
      this.questions.isValid = true;
      return;
    }
    for (let i = 0; i < arrDate.length; i++) {
      let strTemp = arrDate[i]

      for (let j = 0; j < strTemp.length; j++) {
        if ((strTemp.substring(j, j + 1) == " ") || (isNaN(strTemp.substring(j, j + 1)))) {
          this.questions.isValid = true;
          return;
        }
      }
    }
  }

  ValidateNumPhone(objTextBox: any) {

    let phone = objTextBox;

    if (phone == "") {
      this.questions.isValid = false;
      return;
    }

    var phoneFormat = $(objTextBox).attr('telformat');
    var matchArr1, matchArr2, matchArr3, matchArr4;
    matchArr1 = phone.match(/^(\d{13})$/);
    matchArr2 = phone.match(/^\d{3}\s\d{3}\s\d{3}-\d{4}$/);
    matchArr3 = phone.match(/^\d{3}-?\d{10}$/);
    matchArr4 = phone.match(/^\d{3}-\d{3}-\d{3}-\d{4}$/);
    if (matchArr1 != null || matchArr2 != null || matchArr3 != null || matchArr4 != null) {
      if (matchArr4 == null) {
        phone = phone.replace(/-/g, '');
        if (phoneFormat == 'domestic') {
          phone = '(' + phone.substring(0, 3) + ') ' + phone.substring(3, 6) + '-' + phone.substring(6, 10);
        } else {
          phone = '' + phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6, 9) + '-' + phone.substring(9, 13);
        }
      }

      this.questions.AnswerText = phone;

      this.questions.isValid = false;
    } else {
      this.range = true;
      this.questions.isValid = true;
    }
  }
}
